import { useTranslation } from "react-i18next";
import styles from "./MyInboxPublications.module.scss";

const MyInboxTitle: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.myInboxTitle}>
      <h2>{t("publication")} <strong>{t("publicationHUB")}</strong></h2>
      <h3>{t("myInbox")}</h3>
    </div>
  );
};

export default MyInboxTitle;
